import {CreatePlanNode} from "../view-model";

export function collectSelectedPlanNodes(node: CreatePlanNode): string[] {
  const accumulator: string[] = [];
  if (node.selected) {
    accumulator.push(node.caId);
  }
  for (const child of node.children) {
    accumulator.push(...collectSelectedPlanNodes(child));
  }
  return accumulator;
}
